<template>
  <div>
    <v-row v-if="activeType === 'voucher'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.quantity_in_period"
          :label="$t('how_many_vouchers_monthly')"
          type="number"
          outlined
          dense
          :hint="$t('number_of_vouchers_available_monthly')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'order'" class="mb-2">
      <v-col v-if="config.settings.limit_by_quantity" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_orders"
          :label="$t('how_many_orders_monthly')"
          type="number"
          outlined
          dense
          :hint="$t('max_orders_hint')"
          persistent-hint
        />
      </v-col>
      <v-col v-if="config.settings.limit_by_value" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_order_value"
          :label="$t('max_order_value')"
          type="number"
          suffix="KM"
          outlined
          dense
          :hint="$t('max_order_value_hint')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'credit'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_amount"
          :label="$t('credit_amount_monthly')"
          type="number"
          suffix="KM"
          outlined
          dense
          :hint="$t('credit_amount_renews_monthly')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'money'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.limit_amount"
          :label="$t('money_limit_amount_monthly')"
          type="number"
          suffix="KM"
          outlined
          dense
          :hint="$t('money_limit_amount_monthly_hint')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-alert
      v-else-if="
        activeType !== 'voucher' &&
        activeType !== 'order' &&
        activeType !== 'credit' &&
        activeType !== 'money'
      "
      type="info"
      text
      dense
    >
      <div class="font-weight-medium mb-1">Mesečni limit trenutno nije dostupan</div>
      <div class="text-caption">
        Nedostupna polja: Dan u mesecu kada se resetuje limit (1-31), opcija
        proporcionalnog resetovanja
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "MonthlyLimitFields",
  props: {
    config: {
      type: Object,
      required: true,
    },
    activeType: {
      type: String,
      required: true,
    },
  },
};
</script>
